import { withHeadersInstance } from './api-instance.js'
const baseUrl = process.env.VUE_APP_URL_API

export const SendWelcomeEmail = async function(parameters) {
    try {
        const { userPublicId } = parameters
        return await withHeadersInstance({
            method: 'post',
            url: `${baseUrl}/resend-email/${userPublicId}`,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}
